import { z } from 'zod';
/**
 * Locator result — one verified answer to a "where does the Bible talk
 * about ___?" question (Shape 2, STUDY-COMPANION.md).
 *
 * Every field is deterministically derived: verse text from SQLite,
 * pericope title from lookupPericope, reference from formatReference.
 * `entityName` is the token as it literally appears in `verseText` —
 * never the model's own spelling. `sentence` is a server-built template,
 * not model prose. Coordinates are 1-based (wire/SQLite convention).
 */
export const LocatorResultSchema = z.object({
    testament: z.number(),
    bookNumber: z.number(),
    chapterNumber: z.number(),
    verseNumber: z.number(),
    reference: z.string(),
    entityName: z.string().nullable(),
    pericopeTitle: z.string().nullable(),
    verseText: z.string(),
    sentence: z.string(),
});
//# sourceMappingURL=locator-result.js.map